import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { fetchParticipant } from './ducks'
import { Redirect } from 'react-router'

export class ParticipantRedirectSaveProfile {
  static instance
  redirected = false
  constructor () {
    if (ParticipantRedirectSaveProfile.instance) return ParticipantRedirectSaveProfile.instance
    ParticipantRedirectSaveProfile.instance = this
  }
}

const ParticipantCheck = ({
  participant,
  oidc,
  fetchParticipant,
  setInvalidParticipant,
  setInvalidAddress,
  setWillRedirect
}) => {
  const [checkParticipant, setCheckParticipant] = useState(false)
  const [urlToRedirect, setUrlToRedirect] = useState('/profile')

  const {
    address,
    birthDate,
    cnpj,
    cpf,
    cpfCnpj,
    email,
    name,
    partnerCpf,
    phones
  } = participant

  if (!oidc.isLoadingUser && !participant.isLoadingUser && !participant.isParticipantVerify) {
    fetchParticipant()
  }

  const verifySession = () => {
    if (window.sessionStorage.getItem('verificationSignupRedirect')) {
      return false
    }

    return true
  }

  const verificationParticipant = (redirect = true) => {
    let hasHerror = false
    let addressErr = false
    if (participant.isParticipantVerify && !participant.isLoadingUser && process.env.REACT_APP_PARTICIPANT_INCOMPLETE) {
      if (phones && phones.mobile) {
        if ((!phones.mobile.areaCode || !phones.mobile.number)) {
          if (!hasHerror) hasHerror = true
          if (!checkParticipant) {
            if (redirect) setCheckParticipant(true)
            if (!window.sessionStorage.getItem('verificationSignupRedirect') && !participant.willRedirect) {
              setWillRedirect(true)
            }
            if (!participant.invalidParticipant) setInvalidParticipant(true)
          }
        }
      }

      if (birthDate && (!birthDate.disabled && !birthDate.value)) {
        if (!hasHerror) hasHerror = true
        if (!checkParticipant) {
          if (redirect) setCheckParticipant(true)
          if (!window.sessionStorage.getItem('verificationSignupRedirect') && !participant.willRedirect) {
            setWillRedirect(true)
          }
          if (!participant.invalidParticipant) setInvalidParticipant(true)
        }
      }

      if (cnpj && (!cnpj.disabled && !cnpj.value)) {
        if (!hasHerror) hasHerror = true
        if (!checkParticipant) {
          if (redirect) setCheckParticipant(true)
          if (!window.sessionStorage.getItem('verificationSignupRedirect') && !participant.willRedirect) {
            setWillRedirect(true)
          }
          if (!participant.invalidParticipant) setInvalidParticipant(true)
        }
      }

      if (cpf && (!cpf.disabled && !cpf.value)) {
        if (!hasHerror) hasHerror = true
        if (!checkParticipant) {
          if (redirect) setCheckParticipant(true)
          if (!window.sessionStorage.getItem('verificationSignupRedirect') && !participant.willRedirect) {
            setWillRedirect(true)
          }
          if (!participant.invalidParticipant) setInvalidParticipant(true)
        }
      }

      if (cpfCnpj && (!cpfCnpj.disabled && !cpfCnpj.value)) {
        if (!hasHerror) hasHerror = true
        if (!checkParticipant) {
          if (redirect) setCheckParticipant(true)
          if (!window.sessionStorage.getItem('verificationSignupRedirect') && !participant.willRedirect) {
            setWillRedirect(true)
          }
          if (!participant.invalidParticipant) setInvalidParticipant(true)
        }
      }

      if (email && (!email.disabled && !email.value)) {
        if (!hasHerror) hasHerror = true
        if (!checkParticipant) {
          if (redirect) setCheckParticipant(true)
          if (!window.sessionStorage.getItem('verificationSignupRedirect') && !participant.willRedirect) {
            setWillRedirect(true)
          }
          if (!participant.invalidParticipant) setInvalidParticipant(true)
        }
      }

      if (name && (!name.disabled && !name.value)) {
        if (!hasHerror) hasHerror = true
        if (!checkParticipant) {
          if (redirect) setCheckParticipant(true)
          if (!window.sessionStorage.getItem('verificationSignupRedirect') && !participant.willRedirect) {
            setWillRedirect(true)
          }
          if (!participant.invalidParticipant) setInvalidParticipant(true)
        }
      }

      if (partnerCpf && (!partnerCpf.disabled && !partnerCpf.value)) {
        if (!hasHerror) hasHerror = true
        if (!checkParticipant) {
          if (redirect) setCheckParticipant(true)
          if (!window.sessionStorage.getItem('verificationSignupRedirect') && !participant.willRedirect) {
            setWillRedirect(true)
          }
          if (!participant.invalidParticipant) setInvalidParticipant(true)
        }
      }

      if (address) {
        const ignoreIndex = ['reference']
        for (let index in address) {
          if (!address[index].value && ignoreIndex.indexOf(index) < 0) {
            if (!addressErr) addressErr = true
            if (!checkParticipant && !hasHerror) {
              setUrlToRedirect('/my-address')
              if (redirect) setCheckParticipant(true)
              if (!window.sessionStorage.getItem('verificationSignupRedirect') && !participant.willRedirect) {
                setWillRedirect(true)
              }
              if (!participant.invalidAddress) setInvalidAddress(true)
            }
          }
        }
      }
    }

    if (!verifySession() && participant.willRedirect) {
      const sessionCheck = window.sessionStorage.getItem('verificationSignupRedirect')
      setTimeout(() => {
        if (!participant.willRedirect || sessionCheck) return
        setWillRedirect(false)
      }, 5000)
    }

    if (participant.invalidParticipant && !hasHerror) {
      setInvalidParticipant(false)
    }

    if (participant.invalidAddress && !addressErr) {
      setInvalidAddress(false)
    }

    if (addressErr && !participant.invalidAddress) {
      setInvalidAddress(true)
    }
  }

  verificationParticipant()
  useEffect(() => {
    verificationParticipant(false)
  }, [participant])

  const makeSessiton = (verifySession) => {
    if (!verifySession || participant.onlyCashOrPointsBlockRedirect) {
      return false
    }

    window.sessionStorage.setItem('verificationSignupRedirect', 'true')
    return true
  }

  return (<React.Fragment>
    {((checkParticipant && makeSessiton(verifySession()) && !participant.onlyCashOrPointsBlockRedirect && process.env.REACT_APP_PARTICIPANT_INCOMPLETE) && (<Redirect to={urlToRedirect} />))}
  </React.Fragment>)
}

const mapStateToProps = ({
  participant,
  oidc
}) => {
  return {
    participant,
    oidc
  }
}

const mapActionProps = dispatch => ({
  fetchParticipant: () => dispatch(fetchParticipant),
  setInvalidParticipant: (status) => dispatch({
    type: 'UPDATE_PARTICIPANT_INVALID',
    invalidParticipant: status
  }),
  setInvalidAddress: (status) => dispatch({
    type: 'UPDATE_PARTICIPANT_ADDRESS_INVALID',
    invalidAddress: status
  }),
  setWillRedirect: (status) => dispatch({
    type: 'UPDATE_PARTICIPANT_REDIRECT',
    willRedirect: status
  })

})

ParticipantCheck.propTypes = {
  participant: PropTypes.any,
  oidc: PropTypes.any,
  fetchParticipant: PropTypes.func,
  setInvalidParticipant: PropTypes.func,
  setInvalidAddress: PropTypes.func,
  setWillRedirect: PropTypes.func
}

export default connect(mapStateToProps, mapActionProps)(ParticipantCheck)



// WEBPACK FOOTER //
// ./src/Participant/ParticipantCheck.js